export function sum(values: number[]) {
  return values.reduce((total, value) => total + value, 0)
}

export function clamp(num: number, min: number, max: number) {
  return Math.min(Math.max(num, min), max)
}
